import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { map } from 'rxjs'
import { GoalAnalysisService } from './goal-analysis.service'

/** The Goal Analysis tab: admins and holders of the add-on (the server decides). Anyone else
 *  lands on the page's Overview, as for a tab they do not have. */
export const goalAnalysisGuard: CanActivateFn = (route) => {
  const router = inject(Router)
  return inject(GoalAnalysisService).checkAccess().pipe(
    map(ok => ok || router.createUrlTree(route.parent?.url.map(s => s.path).concat('overview') ?? ['/'])),
  )
}
